export default {
  required: (value) => {
    return (!!value && !!value.trim()) || "Campo requerido";
  },
  required2: (value) => {
    return !!value || "Campo requerido";
  },
  minChar: (min) => (value) => {
    return (
      (!!value && value.trim().length >= min) || `Mínimo ${min} caracteres.`
    );
  },
  maxChar: (max) => (value) => {
    return (
      (!!value && value.trim().length <= max) || `Máximo ${max} caracteres.`
    );
  },
  maxFiles: (max) => (files) => {
    return (
      !files || files.length < max || `Se permiten como máximo ${max} imágenes`
    );
  },
  allowedFiles: (types) => (files) => {
    return (
      !files ||
      !files.some((file) => {
        let extIdx = file.name.lastIndexOf(".");
        let ext = "." + file.name.substring(extIdx + 1);
        return !types.includes(ext.toLowerCase());
      }) ||
      `Solo se permiten archivos ${types.map((ext) => `${ext}`)}`
    );
  },
  maxSize: (size) => (files) => {
    const sizeMB = size * 1000 * 1000; //1024 * 1024;
    return (
      !files ||
      !files.some((file) => file.size > sizeMB) ||
      `Tamaño máximo permitido es ${size} MB`
    );
  },
  ticketCantMaxFiles: (cantidadMaxArchivos) => (archivosInput) => {
    return (archivosInput != null && archivosInput.length > 0 && archivosInput.length <= parseInt(cantidadMaxArchivos)) ||
      (archivosInput == null || archivosInput.length === 0) ||
      `Cantidad máxima de archivos permitidos es ${cantidadMaxArchivos}`;
  },
};
